import { type Observable } from 'rxjs'
import { type Job } from '@/features/jobs/Job'
import { filter } from 'rxjs/operators'
import { isNil } from 'lodash-es'

/**
 * Emits a `Job` any time it's time to show the Job Close dialog.
 */
export function jobClosingFlow(
  requestClose$: Observable<Job>,
): Observable<Job> {
  return requestClose$.pipe(
    filter((job) => isNil(job.resolution) || job.resolution === 'Done'),
  )
}
